import previewApi from "../api/preview-api";

/**
 * NMU-451: the preview endpoint does not speak the SUCCESS envelope.
 *
 * nmu-web's POST /api/preview answers `{ token }` on success. It replaced
 * nmu-display-service's /public/savePreview, which did return the envelope, and
 * this check was never updated. So `resp.status` was always undefined,
 * `undefined !== "SUCCESS"` was always true, and every *successful* preview
 * threw `resp.responseMsgTh` — a field that response does not carry either, so
 * what got thrown was literally `undefined`. That is the
 * "nothing usable was thrown: undefined" in the report, and it means the
 * preview button has been broken on every module since the cutover.
 *
 * Failures never reached this line anyway: http-utils throws on any non-2xx, so
 * 401 (session expired), 413 and 503 (no preview store) already surface their
 * own messages. All that matters here is whether a usable token came back.
 */
const savePreview = async (payload) => {
    const resp = await previewApi.savePreview(payload);

    // Kept for a deployment whose preview endpoint still wraps its response:
    // only read `status` as a verdict when it is actually a string.
    if (resp && typeof resp.status === "string" && resp.status !== "SUCCESS") {
        throw resp.responseMsgTh || resp.responseMsgEn || resp.message || resp.status;
    }

    if (!resp || !resp.token) {
        throw "ไม่สามารถสร้างตัวอย่างเว็บไซต์ได้ กรุณาลองใหม่อีกครั้ง | Could not create the preview, please try again";
    }

    return resp;
};

const previewService = {
    savePreview
};

export default previewService;
